import { UrlConstants } from "../url.constants";
export class ApiModuleMapConstants {
    static URL = UrlConstants.API_V2 + "ModuleMap";
    static FUNCTION_DELETE_MULTIPLE_MODULE_MAPS = "DeleteMultipleModuleMaps";
    static FUNCTION_DELETE_ALL_MODULE_MAPS = "DeleteAllModuleMaps";
    static FUNCTION_GET_MODULE_MAP_FOR_AFLA_PORTAL = "GetModuleMapForAFLAPortal";
    static FUNCTION_GET_CEMETERY_SELECTION_MODULE_MAP_FOR_AFLA_PORTAL = "GetCemeterySelectionMapsForAFLAPortal";
    static FUNCTION_GET_ARCGIS_SERVER_TOKENS = "GetArcGISServerTokens";
}
